import { createApp } from "vue";
import RentFormApp from "./app/RentFormApp.vue";
import ContactFormApp from "./app/ContactFormApp.vue";
import SaleFormApp from "./app/SaleFormApp.vue";
import ShareDialogApp from "./app/ShareDialogApp.vue";
import OverlayApp from "./app/OverlayApp.vue";
import TrailerSearchApp from "./app/TrailerSearchApp.vue";

export function mountVueApps() {
    document.querySelectorAll('[data-vue-app="OverlayApp"]').forEach((el) => {
        const app = createApp(OverlayApp);
        app.mount(el);
    });

    document.querySelectorAll('[data-vue-app="ShareDialogApp"]').forEach((el) => {
        const app = createApp(ShareDialogApp);
        app.mount(el);
    });

    document.querySelectorAll('[data-vue-app="TrailerSearchApp"]').forEach((el) => {
        const app = createApp(TrailerSearchApp, {
            rentalPageUrl: el.dataset.rentalPageUrl || '/vermietung',
        });
        app.mount(el);
    });

    document.querySelectorAll('[data-vue-app="RentFormApp"]').forEach((el, i) => {
        const app = createApp(RentFormApp, {
            id: `RentFormAppId-${i+1}`,
            pageUuid: el.dataset.pageUuid
        });
        app.mount(el);
    });

    document.querySelectorAll('[data-vue-app="ContactFormApp"]').forEach((el, i) => {
        const app = createApp(ContactFormApp, {
            id: `ContactFormAppId-${i+1}`,
            pageUuid: el.dataset.pageUuid
        });
        app.mount(el);
    });

    document.querySelectorAll('[data-vue-app="SaleFormApp"]').forEach((el, i) => {
        const app = createApp(SaleFormApp, {
            id: `SaleFormAppId-${i+1}`,
            pageUuid: el.dataset.pageUuid
        });
        app.mount(el);
    });
}
